// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  environment: 'staging',
  production: true,
  loadingArtificialDelay: 1000,
  firebase: {
    apiKey: 'AIzaSyCHVQcHPEhvsT-l1MAe_Q2BlRVuh8MAGiI',
    authDomain: 'auth.commercengine.io',
    databaseURL:
      'https://commerce-engine-352910-default-rtdb.asia-southeast1.firebasedatabase.app/',
    projectId: 'commerce-engine-352910',
    storageBucket: '<your-storage-bucket>',
    messagingSenderId: '<your-messaging-sender-id>',
    appId: '<your-app-id>',
    measurementId: '<your-measurement-id>',
  },
  hmr: false,
  ceStagingApiKey: '22a8603b0fe91f53c2b3c7dcd90b6cf98dd501d1',
  ceProductionApiKey: '22a8603b0fe91f53c2b3c7dcd90b6cf98dd501d1',
  stagingApiUrl: 'https://staging.api.commercengine.io/api/v1/store_id/admin',
  productionApiUrl: 'https://prod.api.commercengine.io/api/v1/store_id/admin',
  tenantManagementApiURL: 'https://tenant.api.commercengine.io/api/v1/admin',
  allowedSubDomains: {},
  hostname: 'localhost:4200',
  loginRedirect: 'home',
  baseHost: 'commercengine.io',
  basePath: '',
};
